<template>
<h5 class="modal-title">
    <slot></slot>
</h5>
</template>

<script>
export default {

}
</script>